/** 
 * © 2025 COMPUTACIÓN EN ACCIÓN, S.A. DE C.V. 'CONTPAQi'. Todos los derechos reservados. 
 * Este código fuente constituye una obra original protegida por la legislación nacional e internacional en materia de propiedad intelectual. 
 * Su reproducción, distribución, comunicación pública, transformación, descompilación, ingeniería inversa o cualquier uso no autorizado, 
 * total o parcial, se encuentra expresamente prohibido sin la previa autorización por escrito de COMPUTACIÓN EN ACCIÓN, S.A. DE C.V. 
 * El uso indebido de este software puede ser constitutivo de delitos y dará lugar a las responsabilidades civiles y penales correspondientes. 
*/ 
 
import { useState, useEffect } from "react";
import { InputStyle, InputType, ActionStatus, PrefixClassName} from "src/constants/theme.constant";

type InputProps = React.InputHTMLAttributes<HTMLInputElement> & {
  className?: string;
  type?: InputType,
  style?: InputStyle;
  status?: ActionStatus;
}

const Input = ({
  className,
  type = InputType.Text,
  style = InputStyle.Primary,
  status,
  ...props
}:InputProps) => {
  const [actionStatus, setActionStatus] = useState<string | undefined>(status);

  const [inputValue, setInputValue] = useState<string | number | readonly string[] | undefined>(props.value);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setInputValue(e.target.value);
    props.onChange && props.onChange(e);
  };

  useEffect(() => {
    setInputValue(props.value);
    return () => {
      setInputValue(undefined);
    };
  }, [props.value]);

  useEffect(() => {
    setActionStatus(status);
    return () => {
      setActionStatus(undefined);
    };
  }, [status]);

  return (
    <>
      <input
        {...props}
        className={`${PrefixClassName}-input-${style} ${className ?? ''} ${actionStatus ? `${PrefixClassName}-input--${actionStatus}`:''}`}
        type={type}
        value={inputValue}
        onChange={handleChange}
      />
    </>
  );
};

export default Input;
